import TimeAdjuster from '@/components/UI/TimeAdjuster'
import { DeliveryTime } from '@/features/orders/types/app'
import { shiftDeliveryTime } from '@/utils/customDeliveryTime'
import { formatDeliveryTime } from '@/utils/formatDeliveryTime'
import dayjs, { ManipulateType } from 'dayjs'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface CustomAcceptedDeliveryTimeAdjusterProps {
    requestedDeliveryTime: DeliveryTime
    customDeliveryTime: DeliveryTime | undefined
    onTimeShiftPress: (deliveryTime: DeliveryTime) => void
    onCancelButton: () => void
    onConfirmButton: () => void
}

const CustomAcceptedDeliveryTimeAdjuster: FC<CustomAcceptedDeliveryTimeAdjusterProps> = ({
    requestedDeliveryTime,
    customDeliveryTime,
    onTimeShiftPress,
    onCancelButton,
    onConfirmButton,
}) => {
    const deliveryTime = customDeliveryTime ?? requestedDeliveryTime

    const { t } = useTranslation()

    const handleCustomTimeShiftPress = (value: number, timeUnit: ManipulateType) => {
        const newCustomDeliveryTime = shiftDeliveryTime(deliveryTime, value, timeUnit)

        onTimeShiftPress(newCustomDeliveryTime)
    }

    const formattedTime = formatDeliveryTime(deliveryTime)

    const applyButtonDisabled =
        deliveryTime.start === requestedDeliveryTime.start &&
        deliveryTime.end === requestedDeliveryTime.end

    return (
        <TimeAdjuster
            title={t('order.detail.acceptationCustomTimeTitle')}
            time={formattedTime}
            applyButtonDisabled={applyButtonDisabled}
            onTimeShiftPress={handleCustomTimeShiftPress}
            onCancelButton={onCancelButton}
            onConfirmButton={onConfirmButton}
            checkDisabled={(option) => {
                if (option.value > 0) {
                    return false
                }

                const newDeliveryTime = shiftDeliveryTime(
                    deliveryTime,
                    option.value,
                    option.timeUnit
                )

                return dayjs(newDeliveryTime.start).isBefore(requestedDeliveryTime.start)
            }}
        />
    )
}

export default CustomAcceptedDeliveryTimeAdjuster
